 	// install a JSONP callback for chunk loading
 	function webpackJsonpCallback(data) {
 		var chunkIds = data[0];
 		var moreModules = data[1];
 		var executeModules = data[2];

 		// add "moreModules" to the modules object,
 		// then flag all "chunkIds" as loaded and fire callback
 		var moduleId, chunkId, i = 0, resolves = [];
 		for(;i < chunkIds.length; i++) {
 			chunkId = chunkIds[i];
 			if(Object.prototype.hasOwnProperty.call(installedChunks, chunkId) && installedChunks[chunkId]) {
 				resolves.push(installedChunks[chunkId][0]);
 			}
 			installedChunks[chunkId] = 0;
 		}
 		for(moduleId in moreModules) {
 			if(Object.prototype.hasOwnProperty.call(moreModules, moduleId)) {
 				modules[moduleId] = moreModules[moduleId];
 			}
 		}
 		if(parentJsonpFunction) parentJsonpFunction(data);

 		while(resolves.length) {
 			resolves.shift()();
 		}

 		// add entry modules from loaded chunk to deferred list
 		deferredModules.push.apply(deferredModules, executeModules || []);

 		// run deferred modules when all chunks ready
 		return checkDeferredModules();
 	};
 	function checkDeferredModules() {
 		var result;
 		for(var i = 0; i < deferredModules.length; i++) {
 			var deferredModule = deferredModules[i];
 			var fulfilled = true;
 			for(var j = 1; j < deferredModule.length; j++) {
 				var depId = deferredModule[j];
 				if(installedChunks[depId] !== 0) fulfilled = false;
 			}
 			if(fulfilled) {
 				deferredModules.splice(i--, 1);
 				result = __webpack_require__(__webpack_require__.s = deferredModule[0]);
 			}
 		}

 		return result;
 	}

 	// The module cache
 	var installedModules = {};

 	// object to store loaded CSS chunks
 	var installedCssChunks = {
 		"app": 0
 	}

 	// object to store loaded and loading chunks
 	// undefined = chunk not loaded, null = chunk preloaded/prefetched
 	// Promise = chunk loading, 0 = chunk loaded
 	var installedChunks = {
 		"app": 0
 	};

 	var deferredModules = [];

 	// script path function
 	function jsonpScriptSrc(chunkId) {
 		return __webpack_require__.p + "js/" + ({"avalon-themeWrapLive":"avalon-themeWrapLive","bb-themeWrap":"bb-themeWrap","bb-themeWrapLive":"bb-themeWrapLive","betcoinsportsxmb-themeWrapLive":"betcoinsportsxmb-themeWrapLive","betflip-themeWrapLive":"betflip-themeWrapLive","bmk-themeWrapLive":"bmk-themeWrapLive","futurebet-themeWrapLive":"futurebet-themeWrapLive","hemingwaynew-themeWrapLive":"hemingwaynew-themeWrapLive","isiparyaj-themeWrapLive":"isiparyaj-themeWrapLive","liveComponent":"liveComponent","lutrijabih-themeWrap":"lutrijabih-themeWrap","lutrijabihlive-themeWrap":"lutrijabihlive-themeWrap","playbetr-themeWrapLive":"playbetr-themeWrapLive","powerbet-themeWrap":"powerbet-themeWrap","powerbet-themeWrapLive":"powerbet-themeWrapLive","prematchModule":"prematchModule","sima-themeWrapLive":"sima-themeWrapLive","sportnaloterija-themeWrapLive":"sportnaloterija-themeWrapLive","themeWrap":"themeWrap","themeWrapLive":"themeWrapLive","themeWrapLiveLight":"themeWrapLiveLight","topbet-themeWrap":"topbet-themeWrap","victory-themeWrapLive":"victory-themeWrapLive","wettnet-themeWrapLive":"wettnet-themeWrapLive","winner-themeWrap":"winner-themeWrap","liveModule":"liveModule","seven-theme":"seven-theme","winner-theme":"winner-theme","winnerbet-theme":"winnerbet-theme"}[chunkId]||chunkId) + "-legacy." + {"chunk-09e7a5c2":"caa2134d","chunk-1391c3f6":"5b895ed4","chunk-1a140d81":"60876e12","chunk-27750698":"f75f39d1","chunk-2d0ac23b":"071353f5","chunk-2d0ce784":"d630eca0","chunk-2d0d5c9e":"660e9121","chunk-2d0dae27":"222d5888","chunk-2d20f202":"1e5ade60","chunk-2d22d404":"7bf155c3","chunk-39712faa":"f30c6f0f","chunk-3da56cd3":"e48e5267","chunk-46df40e3":"66fb169c","chunk-470f7784":"7ee79597","chunk-48fb7bbc":"7c8dafd9","chunk-4ae5ba8a":"fc19d5c7","chunk-4c81e528":"48568f31","chunk-4df6778e":"518a256b","chunk-5081289c":"361b1add","chunk-55be4bda":"bafe62a9","chunk-58465451":"bab09481","chunk-5ed2fbf6":"b80a66c8","chunk-6e0fc165":"186bf118","chunk-780cabd3":"c69bbd50","chunk-7931dd1a":"00bad997","chunk-7efaa700":"cccd07ae","chunk-9f1ac52c":"4c062833","chunk-c9c8a6f8":"39bb63cb","chunk-dae68ae8":"3f4aeb06","chunk-efbc550a":"87cf8f42","chunk-f4c39824":"b832d951","chunk-f80e636a":"f6b519b2","avalon-themeWrapLive":"2ea73c99","bb-themeWrap":"da3d971f","bb-themeWrapLive":"c52bf80d","betcoinsportsxmb-themeWrapLive":"3ff23beb","betflip-themeWrapLive":"788deae2","bmk-themeWrapLive":"298b34b6","chunk-076ff82a":"9c29ee0b","chunk-0ddc1de4":"93801732","chunk-37b458e0":"e32fb0e6","chunk-77eb3c1c":"e9b6049f","chunk-12e40663":"f23346b9","chunk-27a93368":"80aa57f7","chunk-2d21a586":"96bdd832","chunk-516e0b19":"4483b146","chunk-2856dd6c":"f1b4c0c1","chunk-2d05f858":"ab41d14d","chunk-3318285f":"d898b0f2","chunk-34feb6c4":"af841c1f","chunk-39f3fddf":"8b7d77bf","chunk-4d4efe3d":"01f56587","chunk-534a25e4":"1013e63d","chunk-5675e5c2":"434131d1","chunk-57809ec8":"08c0b79a","chunk-51cf79af":"5b5fcd7c","chunk-7e80bcc1":"cc936a41","chunk-f71a9cb8":"b903d9c1","chunk-59b2197b":"371723ca","chunk-5b2054f4":"e277b05a","chunk-5cfb8742":"30737cae","chunk-5d891d5c":"046d723f","chunk-60de5619":"3333909c","chunk-63e1368c":"c1ebcdcf","chunk-650689b8":"c5fc1830","chunk-6a11225c":"fa4834b7","chunk-6ea3ac4c":"eb86cf40","chunk-2d0e1776":"062c33aa","chunk-481db4bc":"f8ccfda0","chunk-787fff9b":"0f6a76ef","chunk-82785576":"2da93c7e","chunk-8c64f80c":"718416d3","chunk-a6508660":"27b38ff0","chunk-a7058df2":"3a381bff","chunk-a72c05d6":"794f4909","chunk-ad54cc74":"674bd4cc","chunk-af6cebae":"4abe53a2","chunk-c11612da":"96314c2f","chunk-c7bd9c24":"f0645b19","chunk-d1e904ac":"34fc1c99","chunk-d2e324d2":"be2a9a4f","chunk-d79d8dbe":"e4a08492","chunk-e5f99d54":"bd548402","chunk-e9a39eee":"c53ab33c","futurebet-themeWrapLive":"55d37897","hemingwaynew-themeWrapLive":"a092a99f","isiparyaj-themeWrapLive":"604265e5","liveComponent":"64cc4c77","lutrijabih-themeWrap":"313af33b","lutrijabihlive-themeWrap":"60b5e6c3","playbetr-themeWrapLive":"c06aa78e","powerbet-themeWrap":"3cdee906","powerbet-themeWrapLive":"0cd9494e","prematchModule":"28f0935d","sima-themeWrapLive":"5840e025","sportnaloterija-themeWrapLive":"79b22967","themeWrap":"39b9bd2e","themeWrapLive":"8ed82368","themeWrapLiveLight":"62b668c7","topbet-themeWrap":"b097acbf","victory-themeWrapLive":"7b39b2f6","wettnet-themeWrapLive":"ad339747","winner-themeWrap":"1ee568a9","liveModule":"f147f184","seven-theme":"e197f007","winner-theme":"ff602fd6","winnerbet-theme":"d7d22a47"}[chunkId] + ".js"
 	}

 	// The require function
 	function __webpack_require__(moduleId) {

 		// Check if module is in cache
 		if(installedModules[moduleId]) {
 			return installedModules[moduleId].exports;
 		}
 		// Create a new module (and put it into the cache)
 		var module = installedModules[moduleId] = {
 			i: moduleId,
 			l: false,
 			exports: {}
 		};

 		// Execute the module function
 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);

 		// Flag the module as loaded
 		module.l = true;

 		// Return the exports of the module
 		return module.exports;
 	}

 	// This file contains only the entry chunk.
 	// The chunk loading function for additional chunks
 	__webpack_require__.e = function requireEnsure(chunkId) {
 		var promises = [];


 		// mini-css-extract-plugin CSS loading
 		var cssChunks = {"chunk-09e7a5c2":1,"chunk-46df40e3":1,"chunk-4c81e528":1,"chunk-55be4bda":1,"chunk-58465451":1,"chunk-7931dd1a":1,"chunk-9f1ac52c":1,"chunk-c9c8a6f8":1,"chunk-f80e636a":1,"avalon-themeWrapLive":1,"bb-themeWrap":1,"bb-themeWrapLive":1,"betcoinsportsxmb-themeWrapLive":1,"betflip-themeWrapLive":1,"bmk-themeWrapLive":1,"chunk-076ff82a":1,"chunk-77eb3c1c":1,"chunk-516e0b19":1,"chunk-2856dd6c":1,"chunk-39f3fddf":1,"chunk-534a25e4":1,"chunk-f71a9cb8":1,"chunk-5b2054f4":1,"chunk-5cfb8742":1,"chunk-60de5619":1,"chunk-63e1368c":1,"chunk-650689b8":1,"chunk-6ea3ac4c":1,"chunk-82785576":1,"chunk-a7058df2":1,"chunk-a72c05d6":1,"chunk-ad54cc74":1,"chunk-af6cebae":1,"chunk-c7bd9c24":1,"chunk-d1e904ac":1,"chunk-d79d8dbe":1,"futurebet-themeWrapLive":1,"hemingwaynew-themeWrapLive":1,"isiparyaj-themeWrapLive":1,"lutrijabih-themeWrap":1,"lutrijabihlive-themeWrap":1,"playbetr-themeWrapLive":1,"powerbet-themeWrap":1,"powerbet-themeWrapLive":1,"sima-themeWrapLive":1,"sportnaloterija-themeWrapLive":1,"themeWrap":1,"themeWrapLive":1,"themeWrapLiveLight":1,"topbet-themeWrap":1,"victory-themeWrapLive":1,"wettnet-themeWrapLive":1,"seven-theme":1,"winner-theme":1,"winnerbet-theme":1};
 		if(installedCssChunks[chunkId]) promises.push(installedCssChunks[chunkId]);
 		else if(installedCssChunks[chunkId] !== 0 && cssChunks[chunkId]) {
 			promises.push(installedCssChunks[chunkId] = new Promise(function(resolve, reject) {
 				var href = "css/" + ({"avalon-themeWrapLive":"avalon-themeWrapLive","bb-themeWrap":"bb-themeWrap","bb-themeWrapLive":"bb-themeWrapLive","betcoinsportsxmb-themeWrapLive":"betcoinsportsxmb-themeWrapLive","betflip-themeWrapLive":"betflip-themeWrapLive","bmk-themeWrapLive":"bmk-themeWrapLive","futurebet-themeWrapLive":"futurebet-themeWrapLive","hemingwaynew-themeWrapLive":"hemingwaynew-themeWrapLive","isiparyaj-themeWrapLive":"isiparyaj-themeWrapLive","liveComponent":"liveComponent","lutrijabih-themeWrap":"lutrijabih-themeWrap","lutrijabihlive-themeWrap":"lutrijabihlive-themeWrap","playbetr-themeWrapLive":"playbetr-themeWrapLive","powerbet-themeWrap":"powerbet-themeWrap","powerbet-themeWrapLive":"powerbet-themeWrapLive","prematchModule":"prematchModule","sima-themeWrapLive":"sima-themeWrapLive","sportnaloterija-themeWrapLive":"sportnaloterija-themeWrapLive","themeWrap":"themeWrap","themeWrapLive":"themeWrapLive","themeWrapLiveLight":"themeWrapLiveLight","topbet-themeWrap":"topbet-themeWrap","victory-themeWrapLive":"victory-themeWrapLive","wettnet-themeWrapLive":"wettnet-themeWrapLive","winner-themeWrap":"winner-themeWrap","liveModule":"liveModule","seven-theme":"seven-theme","winner-theme":"winner-theme","winnerbet-theme":"winnerbet-theme"}[chunkId]||chunkId) + "." + {"chunk-09e7a5c2":"9226e5f0","chunk-1391c3f6":"31d6cfe0","chunk-1a140d81":"31d6cfe0","chunk-27750698":"31d6cfe0","chunk-2d0ac23b":"31d6cfe0","chunk-2d0ce784":"31d6cfe0","chunk-2d0d5c9e":"31d6cfe0","chunk-2d0dae27":"31d6cfe0","chunk-2d20f202":"31d6cfe0","chunk-2d22d404":"31d6cfe0","chunk-39712faa":"31d6cfe0","chunk-3da56cd3":"31d6cfe0","chunk-46df40e3":"9178aab5","chunk-470f7784":"31d6cfe0","chunk-48fb7bbc":"31d6cfe0","chunk-4ae5ba8a":"31d6cfe0","chunk-4c81e528":"acbb924b","chunk-4df6778e":"31d6cfe0","chunk-5081289c":"31d6cfe0","chunk-55be4bda":"56de9bae","chunk-58465451":"8cd663d2","chunk-5ed2fbf6":"31d6cfe0","chunk-6e0fc165":"31d6cfe0","chunk-780cabd3":"31d6cfe0","chunk-7931dd1a":"63fbf16b","chunk-7efaa700":"31d6cfe0","chunk-9f1ac52c":"4da48453","chunk-c9c8a6f8":"81ea3308","chunk-dae68ae8":"31d6cfe0","chunk-efbc550a":"31d6cfe0","chunk-f4c39824":"31d6cfe0","chunk-f80e636a":"c1dd1153","avalon-themeWrapLive":"faf2d477","bb-themeWrap":"5474dfe5","bb-themeWrapLive":"56a98b37","betcoinsportsxmb-themeWrapLive":"634d819a","betflip-themeWrapLive":"7a37142f","bmk-themeWrapLive":"7098805c","chunk-076ff82a":"ad3ecd12","chunk-0ddc1de4":"31d6cfe0","chunk-37b458e0":"31d6cfe0","chunk-77eb3c1c":"da0e52a9","chunk-12e40663":"31d6cfe0","chunk-27a93368":"31d6cfe0","chunk-2d21a586":"31d6cfe0","chunk-516e0b19":"4b483dba","chunk-2856dd6c":"4c60b059","chunk-2d05f858":"31d6cfe0","chunk-3318285f":"31d6cfe0","chunk-34feb6c4":"31d6cfe0","chunk-39f3fddf":"923a0d0e","chunk-4d4efe3d":"31d6cfe0","chunk-534a25e4":"883a6cd0","chunk-5675e5c2":"31d6cfe0","chunk-57809ec8":"31d6cfe0","chunk-51cf79af":"31d6cfe0","chunk-7e80bcc1":"31d6cfe0","chunk-f71a9cb8":"9ab7807b","chunk-59b2197b":"31d6cfe0","chunk-5b2054f4":"3dc2cf22","chunk-5cfb8742":"9573c02d","chunk-5d891d5c":"31d6cfe0","chunk-60de5619":"56fb6014","chunk-63e1368c":"f4fd9d9b","chunk-650689b8":"ea9f214c","chunk-6a11225c":"31d6cfe0","chunk-6ea3ac4c":"6e51e735","chunk-2d0e1776":"31d6cfe0","chunk-481db4bc":"31d6cfe0","chunk-787fff9b":"31d6cfe0","chunk-82785576":"b95a75de","chunk-8c64f80c":"31d6cfe0","chunk-a6508660":"31d6cfe0","chunk-a7058df2":"fbd206a2","chunk-a72c05d6":"f335100f","chunk-ad54cc74":"447cd2c8","chunk-af6cebae":"6a7af2c3","chunk-c11612da":"31d6cfe0","chunk-c7bd9c24":"096208fa","chunk-d1e904ac":"8f647163","chunk-d2e324d2":"31d6cfe0","chunk-d79d8dbe":"e40b804e","chunk-e5f99d54":"31d6cfe0","chunk-e9a39eee":"31d6cfe0","futurebet-themeWrapLive":"7f088620","hemingwaynew-themeWrapLive":"7098805c","isiparyaj-themeWrapLive":"b5ec3658","liveComponent":"31d6cfe0","lutrijabih-themeWrap":"3d27cc80","lutrijabihlive-themeWrap":"ffd8eced","playbetr-themeWrapLive":"9a5257f4","powerbet-themeWrap":"e651742b","powerbet-themeWrapLive":"3b9de4ef","prematchModule":"31d6cfe0","sima-themeWrapLive":"a37c5313","sportnaloterija-themeWrapLive":"78c0b2d5","themeWrap":"6815ed95","themeWrapLive":"ec6a6af2","themeWrapLiveLight":"48568f58","topbet-themeWrap":"21d58845","victory-themeWrapLive":"faf2d477","wettnet-themeWrapLive":"b1927f57","winner-themeWrap":"31d6cfe0","liveModule":"31d6cfe0","seven-theme":"2306f623","winner-theme":"c1429838","winnerbet-theme":"ee892408"}[chunkId] + ".css";
 				var fullhref = __webpack_require__.p + href;
 				var existingLinkTags = document.getElementsByTagName("link");
 				for(var i = 0; i < existingLinkTags.length; i++) {
 					var tag = existingLinkTags[i];
 					var dataHref = tag.getAttribute("data-href") || tag.getAttribute("href");
 					if(tag.rel === "stylesheet" && (dataHref === href || dataHref === fullhref)) return resolve();
 				}
 				var existingStyleTags = document.getElementsByTagName("style");
 				for(var i = 0; i < existingStyleTags.length; i++) {
 					var tag = existingStyleTags[i];
 					var dataHref = tag.getAttribute("data-href");
 					if(dataHref === href || dataHref === fullhref) return resolve();
 				}
 				var linkTag = document.createElement("link");
 				linkTag.rel = "stylesheet";
 				linkTag.type = "text/css";
 				linkTag.onload = resolve;
 				linkTag.onerror = function(event) {
 					var request = event && event.target && event.target.src || fullhref;
 					var err = new Error("Loading CSS chunk " + chunkId + " failed.\n(" + request + ")");
 					err.code = "CSS_CHUNK_LOAD_FAILED";
 					err.request = request;
 					delete installedCssChunks[chunkId]
 					linkTag.parentNode.removeChild(linkTag)
 					reject(err);
 				};
 				linkTag.href = fullhref;

 				var head = document.getElementsByTagName("head")[0];
 				head.appendChild(linkTag);
 			}).then(function() {
 				installedCssChunks[chunkId] = 0;
 			}));
 		}

 		// JSONP chunk loading for javascript

 		var installedChunkData = installedChunks[chunkId];
 		if(installedChunkData !== 0) { // 0 means "already installed".

 			// a Promise means "currently loading".
 			if(installedChunkData) {
 				promises.push(installedChunkData[2]);
 			} else {
 				// setup Promise in chunk cache
 				var promise = new Promise(function(resolve, reject) {
 					installedChunkData = installedChunks[chunkId] = [resolve, reject];
 				});
 				promises.push(installedChunkData[2] = promise);

 				// start chunk loading
 				var script = document.createElement('script');
 				var onScriptComplete;

 				script.charset = 'utf-8';
 				script.timeout = 120;
 				if (__webpack_require__.nc) {
 					script.setAttribute("nonce", __webpack_require__.nc);
 				}
 				script.src = jsonpScriptSrc(chunkId);

 				// create error before stack unwound to get useful stacktrace later
 				var error = new Error();
 				onScriptComplete = function (event) {
 					// avoid mem leaks in IE.
 					script.onerror = script.onload = null;
 					clearTimeout(timeout);
 					var chunk = installedChunks[chunkId];
 					if(chunk !== 0) {
 						if(chunk) {
 							var errorType = event && (event.type === 'load' ? 'missing' : event.type);
 							var realSrc = event && event.target && event.target.src;
 							error.message = 'Loading chunk ' + chunkId + ' failed.\n(' + errorType + ': ' + realSrc + ')';
 							error.name = 'ChunkLoadError';
 							error.type = errorType;
 							error.request = realSrc;
 							chunk[1](error);
 						}
 						installedChunks[chunkId] = undefined;
 					}
 				};
 				var timeout = setTimeout(function(){
 					onScriptComplete({ type: 'timeout', target: script });
 				}, 120000);
 				script.onerror = script.onload = onScriptComplete;
 				document.head.appendChild(script);
 			}
 		}
 		return Promise.all(promises);
 	};

 	// expose the modules object (__webpack_modules__)
 	__webpack_require__.m = modules;

 	// expose the module cache
 	__webpack_require__.c = installedModules;

 	// define getter function for harmony exports
 	__webpack_require__.d = function(exports, name, getter) {
 		if(!__webpack_require__.o(exports, name)) {
 			Object.defineProperty(exports, name, { enumerable: true, get: getter });
 		}
 	};

 	// define __esModule on exports
 	__webpack_require__.r = function(exports) {
 		if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
 			Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
 		}
 		Object.defineProperty(exports, '__esModule', { value: true });
 	};

 	// create a fake namespace object
 	// mode & 1: value is a module id, require it
 	// mode & 2: merge all properties of value into the ns
 	// mode & 4: return value when already ns object
 	// mode & 8|1: behave like require
 	__webpack_require__.t = function(value, mode) {
 		if(mode & 1) value = __webpack_require__(value);
 		if(mode & 8) return value;
 		if((mode & 4) && typeof value === 'object' && value && value.__esModule) return value;
 		var ns = Object.create(null);
 		__webpack_require__.r(ns);
 		Object.defineProperty(ns, 'default', { enumerable: true, value: value });
 		if(mode & 2 && typeof value != 'string') for(var key in value) __webpack_require__.d(ns, key, function(key) { return value[key]; }.bind(null, key));
 		return ns;
 	};

 	// getDefaultExport function for compatibility with non-harmony modules
 	__webpack_require__.n = function(module) {
 		var getter = module && module.__esModule ?
 			function getDefault() { return module['default']; } :
 			function getModuleExports() { return module; };
 		__webpack_require__.d(getter, 'a', getter);
 		return getter;
 	};

 	// Object.prototype.hasOwnProperty.call
 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };

 	// __webpack_public_path__
 	__webpack_require__.p = "/";

 	// on error function for async loading
 	__webpack_require__.oe = function(err) { console.error(err); throw err; };

 	var jsonpArray = window["webpackJsonp"] = window["webpackJsonp"] || [];
 	var oldJsonpFunction = jsonpArray.push.bind(jsonpArray);
 	jsonpArray.push = webpackJsonpCallback;
 	jsonpArray = jsonpArray.slice();
 	for(var i = 0; i < jsonpArray.length; i++) webpackJsonpCallback(jsonpArray[i]);
 	var parentJsonpFunction = oldJsonpFunction;


 	// add entry module to deferred list
 	deferredModules.push([0,"chunk-vendors~253ae210","chunk-vendors~9c5b28f6"]);
 	// run deferred modules when ready
 	return checkDeferredModules();
